module.exports = __webpack_public_path__ + "static/img/数据智能体_文字_png@2x.2e747e86.png";